module.exports = __webpack_public_path__ + "static/img/cert-brand-2.de378b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert-brand-2.png
// module id = qcyp
// module chunks = 0